import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import * as rk from "../../localization/resourceKeys";
import i18n from "../../i18n";
import BottomLine from "../Footer/BottomLine";
import PropTypes from "prop-types";

const RightToWithdraw = ({ currentStateResidence, country }) => {
  const history = useHistory();

    const withdrawContent = () => {
      if (country.toLowerCase() === "canada" && currentStateResidence === "QC") {
        return (
          <div className="withdraw-wrapper">
            <div className="welcome-note">
              {i18n.t(rk.REQUEST_SELECTOR.WITHDRAW_QC)}
            </div>

            <div className="welcome-note">
              <p>{i18n.t(rk.REQUEST_SELECTOR.WITHDRAW_CARD_BODY_QC_1)}</p>
            </div>
            <div className="welcome-note">
              <p>{i18n.t(rk.REQUEST_SELECTOR.WITHDRAW_CARD_BODY_QC_2)}</p>
            </div>
            <div className="welcome-note">
              <p>{i18n.t(rk.REQUEST_SELECTOR.WITHDRAW_CARD_BODY_QC_3)}</p>
            </div>
            <div className="welcome-note">
              <p>{i18n.t(rk.REQUEST_SELECTOR.WITHDRAW_CARD_BODY_QC_4)}</p>
            </div>
          </div>
        );
      } else {
        return history.push("/");
      }
    };

    return (
      <>
        {withdrawContent()}
        <div className="request-footer-wrapper">
          <BottomLine />
        </div>
      </>
    );
};

RightToWithdraw.propTypes = {
  currentStateResidence: PropTypes.string,
  country: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    country: state.initialReducer.country,
    currentStateResidence: state.stateSelector.currentStateResidence,
  };
};

export default connect(mapStateToProps)(RightToWithdraw);
